import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GeneralService } from '../../../shared/services/general.service';
import { ProfileDetails } from '../../../shared/constants';

@Component({
  selector: 'app-profile-tab',
  templateUrl: './profile-tab.component.html',
  styleUrls: ['./profile-tab.component.scss']
})
export class ProfileTabComponent implements OnInit {
  ProfileDetails = ProfileDetails;
  @Input() defaultTab: string;
  @Input() gasMeterId: String;
  tab: string;

  @Output()
  change: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(private route: ActivatedRoute,
              private generalService: GeneralService) { }

  ngOnInit() {
    this.tab = this.defaultTab;
    this.route.queryParams.subscribe(values => {
      if (Object.keys(ProfileDetails).map(k => k.split('_').join(' ')).includes(values.profileType)) {
        this.tab = values.profileType;
        this.change.emit(values.profileType !== undefined);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/profile/profile-tab/profile-tab.component.ts